import {
    Size,
    Breakpoint,
    ZPG_DFP_NETWORK,
    DFP_AD_UNIT,
    AD_UNIT_ROOTS,
    AD_UNIT_SECTION,
    AD_UNIT_PAGE,
    ADBRIDG_CLASS
} from './types';
import { adWrapperStyle } from './Styles.css';
import { bpVariant } from './breakpoints';

type DeprecatedProps = {
    sizes: Size[];
    position: number;
    adUnitCode?:
        | DFP_AD_UNIT
        | [AD_UNIT_ROOTS, AD_UNIT_SECTION]
        | [AD_UNIT_ROOTS, AD_UNIT_SECTION, AD_UNIT_PAGE]
        | [AD_UNIT_ROOTS, AD_UNIT_SECTION, string];
    dfpNetworkId?: ZPG_DFP_NETWORK.ID;
    collapseEmpty?: boolean;
    uuid?: string;
};

/* To help avoid cumulative layout shift we should set a reasonable min height on the ad slots */
const MIN_HEIGHTS: Record<ADBRIDG_CLASS, number> = {
    [ADBRIDG_CLASS.TEXT_LINK_LSRP]: 108,
    [ADBRIDG_CLASS.MPU]: 250,
    [ADBRIDG_CLASS.VALUATION_BOOSTER]: 50,
    [ADBRIDG_CLASS.MPU_2]: 250,
    [ADBRIDG_CLASS.SKYSCRAPER]: 0 /* doesn't matter as sticky */,
    [ADBRIDG_CLASS.SKYSCRAPER_2]: 0 /* doesn't matter as sticky */,
    [ADBRIDG_CLASS.INTERSTITIAL_DESKTOP]: 250,
    [ADBRIDG_CLASS.INTERSTITIAL_MOBILE]: 250,
    [ADBRIDG_CLASS.SPONSOR_MOBILE]: 0,
    [ADBRIDG_CLASS.TEXT_LINK_LDP]: 0,
    [ADBRIDG_CLASS.SPONSOR_DESKTOP]: 0,
    [ADBRIDG_CLASS.TEXT_LINK_MH]: 0,
    [ADBRIDG_CLASS.TEXT_LINK]: 0,
    [ADBRIDG_CLASS.INLINE_SPECIAL]: 108,
    [ADBRIDG_CLASS.ADB_FLUID]: 0,
    [ADBRIDG_CLASS.ADB_TEXT_LINK]: 108
};

export const AdbridgSlot: React.FC<
    {
        adbridgClass?: string;
        adbridgDataClass?: string;
        hasMarginTop?: boolean;
        height?: number;
        showOnly?: Breakpoint;
    } & DeprecatedProps
> = ({
    adbridgClass,
    adbridgDataClass,
    hasMarginTop = true,
    height,
    showOnly,
    sizes,
    position,
    uuid
}) => {
    const testid = `dfp_${
        typeof sizes[0] === 'string' ? sizes[0] : sizes[0].join('x')
    }_${position}${uuid ? `_${uuid}` : ''}`;

    const resolvedClass =
        adbridgDataClass === ADBRIDG_CLASS.ADB_TEXT_LINK
            ? adbridgDataClass
            : adbridgClass;

    const minHeight =
        height ?? MIN_HEIGHTS[resolvedClass as ADBRIDG_CLASS] ?? 0;

    return (
        <div
            className={adWrapperStyle({ breakpoint: bpVariant(showOnly) })}
            style={{ height }}
        >
            <div
                itemScope={true}
                itemType="https://schema.org/WPAdBlock"
                className="zad-slot"
                style={{
                    marginTop: hasMarginTop ? '16px' : 0,
                    width: '100%',
                    minHeight: `${minHeight}px`,
                    overflow: 'hidden'
                }}
                data-adbridg-ad-class={resolvedClass}
                data-testid={testid}
            />
        </div>
    );
};
